import { DefaultLayer } from "./DefaultLayer";

class WfsLayer extends DefaultLayer {
  constructor(layer_data) {
    super(layer_data);

    this.id = this.id.replace(layer_data.uuid, `wfs-${layer_data.uuid}`);
  }

  getFeatureInfoOnClick = (evt, map) => {
    const layer = this.layer;

    const clickedCoordinate = evt.coordinate_;
    const [lon, lat] = clickedCoordinate;

    const source = layer.getSource();

    const features = source.getFeatures();
    if (!features.length) {
      console.error("No se encontraron features en la capa WFS.");
      return [];
    }

    // Pequeño margen para considerar puntos cercanos al clic
    const tolerance = map.getView().getResolution() * 10;

    let closestFeature = null;
    let minDistance = Infinity;

    features.forEach((feature) => {
      const geometry = feature.getGeometry();
      if (geometry) {
        const featureCoord = geometry.getClosestPoint(clickedCoordinate);
        const distance = Math.sqrt(
          Math.pow(featureCoord[0] - lon, 2) +
            Math.pow(featureCoord[1] - lat, 2)
        );

        if (distance < minDistance && distance <= tolerance) {
          minDistance = distance;
          closestFeature = feature;
        }
      }
    });

    if (closestFeature) {
      // Convertir la geometría a formato GeoJSON
      const geometry = closestFeature.getGeometry().clone();
      geometry.transform(map.getView().getProjection(), "EPSG:4326");

      let geoJsonGeometry = {};
      const type = geometry.getType();
      const validTypes = [
        "Polygon",
        "MultiPolygon",
        "Point",
        "MultiPoint",
        "LineString",
        "MultiLineString",
      ];

      if (validTypes.includes(type)) {
        geoJsonGeometry = {
          type,
          coordinates: geometry.getCoordinates(),
        };
      } else {
        console.warn("Tipo de geometría no manejado:", type);
        return [];
      }

      return [
        {
          geometry: geoJsonGeometry,
          geometry_name: "geometry",
          id: layer.getProperties().id,
          layer_name: layer.getProperties().name,
          properties: closestFeature.getProperties(),
        },
      ];
    } else {
      console.warn("No se encontró ninguna feature dentro del margen.");
      return [];
    }
  };
}

export { WfsLayer };
